import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { INavData } from '@coreui/angular-pro';
import { MenuModel } from '@domain/models/general/menu.model';
import { KeycloakService } from 'keycloak-angular';

/**
 *Gestiona la cuenta del usuario, accesos y realiza las comprobaciones de validación.
 *
 * @author Jose Manuel Landero Gonzalez
 * @export
 * @class AccountService
 */
@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private isLogin = false;
  private userData = null;

  constructor(
    private router: Router,
    private readonly keycloak: KeycloakService,
    private route: ActivatedRoute
  ) {
    console.log('Account');
  }

  public async verifyLogin(): Promise<void> {
    this.isLogin =
      (await this.keycloak.isLoggedIn()) && !this.keycloak.isTokenExpired();
  }

  public async reloadSession(){
    this.keycloak.clearToken();
    this.keycloak.login();
  }

  public hasLogin(): boolean {
    return this.isLogin;
  }

  public setIsLogin(isLogin: boolean): void {
    this.isLogin = isLogin;
  }

  public navigateToHome(): void {

    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
    this.router.navigateByUrl(returnUrl);
  }

  public navigateToLogin(): void {
    this.keycloak.login();
  }

  public setUserData(userData: any) {
    this.userData = userData;
  }

  public getUserData(): any {
    return this.userData;
  }
}
